/** The tag's underlying value type, distinct from Tag Type (mode/state/alarm/...). */
export const DATA_TYPE_OF_VALUES = {
  INTEGER: 'INTEGER',
  BOOLEAN: 'BOOLEAN',
  FLOAT: 'FLOAT',
} as const;

export type DataTypeOfValuesValue = (typeof DATA_TYPE_OF_VALUES)[keyof typeof DATA_TYPE_OF_VALUES];
